import classnames from 'classnames';
import React, { Component } from 'react';
//utils
import { isEmptyObject, safeGet } from '../../../../../utils';
//children
import { Translations, convertStringToArrayForOption, translateStatus } from '../../../../../utils';
import AccountSection from '../AccountSection';
//style
import SimpleDropdown from '../../../../common/SimpleDropdown';
import './SweepInstructionsList.css';

export default class SweepInstructionsList extends Component {
  constructor(props) {
    super(props);
    this.currentAccount = {};
  }
  isReadOnly = () => {
    const { customer, isCustAck, caseMenu } = this.props || {}
    return customer && (customer.roleDetails.customer || isCustAck) || (caseMenu && caseMenu.isEditing &&
      (caseMenu.editingUserEmail !== customer.emailAddress))

  }

  setCurrentAccount = (accountId) => {
    this.currentAccount = this.props.accounts.find(account => account.id === accountId);
  }
  getSweepName(type) {
    let name;
    if (this.props.sweepTypes && this.props.sweepTypes !== undefined) {
      this.props.sweepTypes.filter(countItem => {
        if (countItem.id === type) {
          name = countItem.name
        }
      })
      return name;
    }
  }

  getSweepTypeJsx = (item) => {
    var currentWord = this.props.pageJson !== undefined && this.props.pageJson.staticText_sweepInstructions !== undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.region, this.props.lang.currentLang.lang, this.props.lang.translatedData) : '';
    const region = convertStringToArrayForOption(currentWord);
    var sweepType = this.getSweepName(safeGet(item, "sweepParticipantsAccounts.sweepType.value")) || '';
    var accountRegion = safeGet(item, "sweepParticipantsAccounts.accountRegion");
    if (sweepType !== '' && accountRegion !== '') {
      if (accountRegion === 'crossBorder') {
        accountRegion = region !== undefined ? region[0].split("=")[1] : ''
      }
      else {
        accountRegion = region !== undefined ? region[1].split("=")[1] : ''
      }
      return `${sweepType}, ${accountRegion}`;
    } else if (sweepType !== '') {
      return sweepType;
    }
  }

  getAccountCountryTaxanomy(accounts) {
    if (this.props.accountList !== undefined) {
      if (accounts !== undefined) {
        accounts = accounts.map(item => {
          this.props.accountList.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
                if (item.accountType !== undefined) {
                  countItem.associations.filter(accountType => {
                    if (accountType.id === item.accountType.value) {
                      item.accountType.name = accountType.name
                    }
                  })
                }
              }
            }
            return item;
          });
          return accounts;
        });
      }
    }
  }

  render() {
    return (
      <div className="sweep-instructions-wrapper">
        {
          this.props.items.map((item, index) => (
            <div className="sweep-instruction" key={item.id || index}>
              <div role="link" className="sweep-instruction__sweep-details">
                <SweepName item={item} _onClick={this.props._onClick} readOnlyList={this.props.readOnlyList} />
                <p className="sweep-instruction__sweep-details__sweep-type">
                  {this.getSweepTypeJsx(item)}
                </p>
              </div>
              <AccountSection type="master" master={this.props.pageJson !== undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.master, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
                sweepInstruction={item} accounts={this.getAccountCountryTaxanomy(this.props.accounts) || this.props.accounts} bsClass="sweep-instruction-account-section" listType={this.props.listType} />
              <AccountSection type="sub" sub={this.props.pageJson !== undefined ? Translations(this.props.pageJson.staticText_sweepInstructions.sub, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
                sweepInstruction={item} accounts={this.getAccountCountryTaxanomy(this.props.accounts) || this.props.accounts} bsClass="sweep-instruction-account-section" listType={this.props.listType} />
              {
                !this.props.readOnlyList ?
                  <SweepStatus key="sweep-status-section" status={item.status} lang={this.props.lang} />
                  : ''
              }
              {
                this.props.copySweepFrom && this.props.items.length ?
                  <section className='copy-sweep-from-container'>
                    <span className='label-text'>
                      Copy From
                    </span>
                    <section className='dropdown-container'>
                      <SimpleDropdown
                        name="copySweepFrom"
                        options={this.props.items.filter((el, elIndex) => elIndex !== index && !isEmptyObject(el.sweepParticipantsAccounts)) || []}
                        optionTextSelector="sweepId"
                        defaultValue={"Please select"}
                        disabled={this.props.sow && this.isReadOnly()}
                        // value={this.state.sweepParticipantsAccounts.sweepType ? this.state.sweepParticipantsAccounts.sweepType.value : ''}
                        _onChange={(e) => this.props.handleCopySweepFrom(e, item.id)}
                      ></SimpleDropdown>
                    </section>
                  </section>
                  : null
              }
              {
                !this.props.readOnlyList ?

                  <Delete key="delete-section" item={item} _disabled={this.props.disabled} _onDelete={this.props._onDelete}
                    disabled={this.props.sow && this.isReadOnly()} />
                  : ''
              }


            </div>
          ))
        }
      </div>
    );
  }
}

class SweepName extends React.Component {
  _onClick = (e) => {
    if (this.props._onClick) {
      this.props._onClick(this.props.item);
    }
  }

  _onEnter = (event) => {
    if (event.keyCode === 13) {
      if (this.props._onClick) {
        this.props._onClick(this.props.item);
      }
    }
  }
  render() {
    var css = classnames('sweep-instruction__sweep-details__sweep-name', {
      'read-only-list': this.props.readOnlyList
    });
    return (
      <label className={css} onClick={this._onClick} onKeyDown={this._onEnter} role='link' tabIndex={0}>
        {this.props.item.sweepId}
        <span>{safeGet(this.props.item, "sweepParticipantsAccounts.currency.name", undefined) ? `(${safeGet(this.props.item, "sweepParticipantsAccounts.currency.name")})` : ''}</span> <i className="icon icon-chevron-right" aria-hidden="true"></i>
      </label>
    );
  }
}

class Delete extends React.Component {
  _onDelete = (e) => {
    if (this.props.disabled) {
      return
    }
    else {
      if (this.props._onDelete) {
        this.props._onDelete(this.props.item);
      }
    }
  }
  render() {
    return (
      (!this.props._disabled)
        ? <div role="link" tabindex="0" className="sweep-instruction__delete">
          <i className="icon icon-bin" onClick={this._onDelete}></i>
        </div>
        : ''
    )
  }
}

const SweepStatus = (props) => {
  var iconClass = classnames('status-icon', 'gdocs-float-left', 'icon', {
    'icon-circle-confirmation-solid complete': props.status === 'complete',
    'icon-circle-error-solid incomplete': props.status !== 'complete'
  });
  var statusText = translateStatus(props.lang.currentLang.lang, props.status);
  return (
    <div className="sweep-instruction__status">
      <div className={iconClass} aria-hidden="true"></div>
      <div className="gdocs-float-left status-text">{statusText}</div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/SweepInstructionsList/SweepInstructionsList.js